import { render, staticRenderFns } from "./PaymentV2Form.vue?vue&type=template&id=0585d8be&"
import script from "./PaymentV2Form.vue?vue&type=script&lang=js&"
export * from "./PaymentV2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports